import React, { Component } from 'react';
import { isEmpty } from 'lodash';

import  {
    IconButton,
    FormHelperText,
    Grid,
} from '@mui/material';

import Currency from '../../common/Currency';
import { MONTHS } from '../../../utils/generalFuncs';
import Creatable from '../../common/Creatable';
import InputText from '../../common/Form';
import { CloseRounded } from '@mui/icons-material';


class PaymentLine extends Component {
    state = {
        acompte: 0,
        rest: 0,
        supplier: {}
    }
    componentDidMount = () => {
        console.log('=================CDM===================');
        console.log();
        console.log('====================================');
        const { SUPPLIERS, spending } = this.props;
        if (spending && SUPPLIERS[spending.spending_supplier] && (SUPPLIERS[spending.spending_supplier].supplier_account > 0)) {
            let acompte = SUPPLIERS[spending.spending_supplier].supplier_account
            let rest = (this.props.payment_amount - acompte > 0) ? this.props.payment_amount - acompte : 0
            this.setState({
                acompte,
                supplier: SUPPLIERS[spending.spending_supplier],
                rest: rest
            })
            this.props.handleChange("payment_amount", parseFloat(rest) , this.props.index)
        }
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/

        if(name === "payment_amount" || name === "payment_advance_amount"){
            if(regex.test(value) || value === ""){
                this.props.handleChange(name, parseFloat(value) , this.props.index)
            }
        } else {
            this.props.handleChange(name, value , this.props.index)
        }
    }
    handleChangeCreatable = (option, name) => {
        this.props.handleChangeCreatable(option, name, this.props.index)
    }
    deleteLine = (e) => {
        this.props.deleteLine(this.props.index)
    }

    render() {
        const { index, SPENDINGS, SALARIES, SALARY_CATS, EMPLOYEES, CHARGES, SUPPLIERS, selected, salary, charge, spending, errors } = this.props;
        const { acompte, supplier } = this.state;
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
        console.log('====================================');
        console.log({spending});
        console.log('====================================');
        return (
            <div>
                <hr/>
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <h6>Dépense {index + 1}</h6>
                     
                    <Grid container spacing={2}>
                        <Grid item xs={1} >
                            <IconButton onClick={this.deleteLine}>
                                <CloseRounded color="error" />
                            </IconButton>
                        </Grid>
                        <Grid item sm={acompte > 0 ? 6 : 8} xs={11}>
                            {SALARY_CATS && EMPLOYEES && this.props.payment_is_salary &&
                                <Creatable
                                    required
                                    error={errors.payment_salary_id}
                                    label="Salaire"
                                    onChange={(option) => this.handleChangeCreatable(option, "payment_salary_id")}
                                    name="payment_salary_id" 
                                    id="payment_salary_id"
                                    options={
                                        Object.values(SALARIES).map( item => ({
                                            value: item.salary_id, 
                                            label: `${new Date(item.salary_date).toLocaleDateString("fr-FR") } | Salaire ${ MONTHS[new Date(item.salary_period_end).getMonth()]} ${new Date(item.salary_period_end).getFullYear() } - ${ item.salary_employee && 
                                                EMPLOYEES[item.salary_employee].employee_lastname
                                            } ${ item.salary_employee && 
                                                EMPLOYEES[item.salary_employee].employee_firstname
                                            } | ${item.salary_to_pay.toLocaleString("fr-FR")}`,
                                            disabled: selected.includes(item.salary_id)
                                        }
                                    ))}
                                    value={this.props.payment_salary_idDisplay || {value:"", label:""}}
                                />

                            }
                            {SALARY_CATS && EMPLOYEES && this.props.payment_is_charge &&
                                <Creatable
                                    required
                                    error={errors.payment_charge_id}
                                    label="Charge"
                                    onChange={(option) => this.handleChangeCreatable(option, "payment_charge_id")}
                                    name="payment_charge_id" 
                                    id="payment_charge_id"
                                    options={
                                        Object.values(CHARGES).map( item => ({
                                            value: item.salary_line_id, 
                                            label: `${new Date(item.salary_line_date).toLocaleDateString("fr-FR") } | ${
                                                item.salary_line_name && SALARY_CATS[item.salary_line_name].salary_cat_name
                                            } - ${ item.salary_line_employee && 
                                                EMPLOYEES[item.salary_line_employee].employee_lastname
                                            } ${ item.salary_line_employee && 
                                                EMPLOYEES[item.salary_line_employee].employee_firstname
                                            } | ${item.salary_line_retenue.toLocaleString("fr-FR")}`,
                                            disabled: selected.includes(item.salary_line_id)
                                        }
                                    ))}
                                    value={this.props.payment_charge_idDisplay || {value:"", label:""}}
                                />

                            }
                            {!this.props.payment_is_salary && !this.props.payment_is_charge &&
                                <Creatable
                                    required
                                    error={errors.payment_spending_id}
                                    label="Dépense"
                                    onChange={(option) => this.handleChangeCreatable(option, "payment_spending_id")}
                                    name="payment_spending_id" 
                                    id="payment_spending_id"
                                    options={
                                        Object.values(SPENDINGS).map( item => ({
                                            value: item.spending_id, 
                                            label: `${new Date(item.spending_date).toLocaleDateString("fr-FR") } | ${item.spending_desc} |  ${item.spending_amountTTC.toLocaleString("fr-FR")}`,
                                            disabled: selected.includes(item.spending_id)
                                        }
                                    ))}
                                    value={this.props.payment_spending_idDisplay || {value:"", label:""}}
                                />
                            }
                        </Grid>
                        {!isEmpty(spending) && !this.props.payment_is_salary && !this.props.payment_is_charge && (acompte > 0) &&
                            <Grid item sm={2} xs={12}>
                                {/* <Creatable
                                    required
                                    error={errors.payment_details_advance}
                                    label="Acompte"
                                    onChange={(option) => this.handleChangeCreatable(option, "payment_details_advance")}
                                    name="payment_details_advance" 
                                    id="payment_details_advance"
                                    options={
                                        // Object.values(spending.advance_list).filter(advance => advance.advance_spent === false).map( item => ({
                                        Object.values(supplier.advance_list).map( item => ({
                                            value: item.advance_id, 
                                            label: `${new Date(item.advance_date).toLocaleDateString("fr-FR") } | ${item.advance_ref} |  ${item.advance_amount.toLocaleString("fr-FR")}`,
                                        }
                                    ))}
                                    value={this.props.payment_details_advanceDisplay || {value:"", label:""}}
                                /> */}
                                <InputText
                                    onChange={this.handleChange}
                                    // disabled
                                    id="payment_advance_amount"
                                    error={errors.payment_advance_amount}
                                    value={this.props.payment_advance_amount}
                                    name="payment_advance_amount"
                                    label="Acompte"
                                    type="number"                              
                                />
                                <FormHelperText >Acompte total : {acompte}</FormHelperText>
                            </Grid>
                        }
                        <Grid item sm={3} xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="payment_amount"
                                error={errors.payment_amount}
                                value={this.props.payment_amount}
                                name="payment_amount"
                                label="Montant"
                                type="number"                              
                            />
                            {!isEmpty(salary) && 
                                <FormHelperText >Reste à Payer : <Currency value={salary.salary_rest_to_pay} /> </FormHelperText>
                            }
                            {!isEmpty(charge) && 
                                <FormHelperText >Reste à Payer : <Currency value={charge.salary_line_rest_to_pay} /> </FormHelperText>
                            }
                            {!isEmpty(spending) && 
                                <FormHelperText >Reste à Payer : <Currency value={spending.spending_rest_to_pay - this.props.payment_advance_amount}/> {this.props.payment_advance_amount > 0 && `(${spending.spending_rest_to_pay} - ${this.props.payment_advance_amount})`}</FormHelperText>
                            }
                        </Grid>
                    </Grid>
                </div>                
            </div>
        );
    }
}


export default PaymentLine 